module.exports = __webpack_public_path__ + "h5/img/tgmp@3x.47cdc057.png";